import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { salesHomeRoute, HttpStatus } from 'config/Api.Config';
import ContractRefundInvoiceSendEmail from './components/Sales.ContractRefundInvoice.SendEmail';
import useContractRefundInvoice, { ContractRefundInvoiceAction } from './Sales.ContractRefundInvoice.Hooks';
import ContractRefundInvoiceList from './sections/Sales.ContractRefundInvoice.List';

export const salesContractRefundInvoiceIndexRoute = salesHomeRoute + '/contractRefundInvoice/:action?/:id?';
export default function SalesContractRefundInvoiceIndex() {
  const contractRefundInvoiceHook = useContractRefundInvoice();

  if (!contractRefundInvoiceHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={contractRefundInvoiceHook}
        render={({ pageRouter }) => (
          <>
            <ContractRefundInvoiceList />
            {pageRouter.params?.id && pageRouter.params?.action === ContractRefundInvoiceAction.SEND_EMAIL && (
              <ContractRefundInvoiceSendEmail />
            )}
          </>
        )}
      />
    </>
  );
}
